import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      style={{ background: "var(--charcoal)", color: "var(--pearl)" }}
    >
      <div className="container-wide pt-24 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-7">
            <p className="label-mono-light mb-6">— Manifesto Line</p>
            <h2
              className="font-display font-bold leading-[0.95]"
              style={{
                fontSize: "clamp(2.25rem, 6vw, 5rem)",
                letterSpacing: "-0.04em",
              }}
            >
              Regeneration is the next
              <br />
              <span style={{ color: "var(--mulberry-bright)" }}>
                global infrastructure.
              </span>
            </h2>
          </div>

          <div className="md:col-span-5 grid grid-cols-2 gap-8">
            <div>
              <p className="label-mono-light mb-4">Sitemap</p>
              <ul className="space-y-2 font-display text-sm tracking-wide">
                <li>
                  <Link to="/about" className="link-underline">
                    About
                  </Link>
                </li>
                <li>
                  <Link to="/vision" className="link-underline">
                    Vision
                  </Link>
                </li>
                <li>
                  <Link to="/future" className="link-underline">
                    Future
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="link-underline">
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <p className="label-mono-light mb-4">Mail</p>
              <a
                href="mailto:engage@folksfoundation.com"
                data-testid="footer-email"
                className="font-display text-base link-underline"
                style={{ color: "var(--mulberry-bright)" }}
              >
                engage@folksfoundation.com
              </a>
              <p className="label-mono-light mt-6 mb-2">Hours</p>
              <p className="font-body text-base leading-snug opacity-80">
                Mon — Fri · By appointment
                <br />
                for institutional meetings.
              </p>
            </div>
          </div>
        </div>

        <div className="divider-line-inv mt-20 pt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="label-mono-light">
            © {new Date().getFullYear()} Folks Foundation — A long-duration
            regenerative institution.
          </p>
          <p className="label-mono-light">
            01 / Civilizational · 02 / Long-duration · 03 / Sovereign-grade
          </p>
        </div>
      </div>
    </footer>
  );
}
